import { render, staticRenderFns } from "./component.vue?vue&type=template&id=2fd1afb4&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=2fd1afb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1afb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd1afb4')) {
      api.createRecord('2fd1afb4', component.options)
    } else {
      api.reload('2fd1afb4', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=2fd1afb4&scoped=true&", function () {
      api.rerender('2fd1afb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-table-columns-filter/component.vue"
export default component.exports